import { useState } from 'react'
import styled from 'styled-components'
import FlagIcon from 'components/Common/FlagIcon'
import LanguagesListPopup from './LanguagesListPopup'
import { getSelectedLocale } from 'utils/getLocaleId'
import { useChangeLocaleMutation } from 'api/hooks'
import i18n from 'utils/i18n'
import { HARDCODE_LANGS } from '../_methods/hardcodeLangs'

const Wrapper = styled.button`
  all: unset;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  /* width: 100%; */
  padding: 8px;
  box-sizing: border-box;
  cursor: pointer;
  background: #fff;
  border: 1px solid #e7e7ea;
  border-radius: 4px;

  :hover,
  :active {
    background: var(--grey-2-g-3);
  }
`

const Value = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`

const Text = styled.div`
  color: var(--color-sw-60);
  font: var(--typography-12-16-semibold);
`

const getFlagCodeFromLocale = (locale: string) => {
  if (locale === 'en') return 'gb'
  if (locale === 'zh') return 'cn'
  return locale
}

interface LanguageSelectorProps {
  skipMutation?: boolean
  onAfterSelect?: (locale: string) => void
}

const LanguageSelector = ({
  skipMutation = false,
  onAfterSelect,
}: LanguageSelectorProps) => {
  const [opened, setOpened] = useState(false)
  const [value, setValue] = useState(() => {
    return {
      locale: getSelectedLocale(),
      name: ' ',
    }
  })
  const [changeLocale] = useChangeLocaleMutation()

  const handleSelect = async v => {
    setValue({ locale: v.locale, name: v.name })
    if (!skipMutation) {
      await changeLocale({
        variables: {
          localeId: v?.id,
        },
      })
    }
    localStorage.setItem('wwl-lng', v.locale)
    i18n.changeLanguage(v.locale)
    onAfterSelect?.(v.locale)
    setOpened(false)
  }

  return (
    <>
      <Wrapper
        onClick={() => setOpened(true)}
        type='button'
        data-testid='onboarding-header-language-button'
      >
        <Value>
          <FlagIcon
            codeISO={getFlagCodeFromLocale(value?.locale)}
            width={24}
            height={16}
          />
          <Text>{value?.locale.toUpperCase()}</Text>
        </Value>
      </Wrapper>
      {opened && (
        <LanguagesListPopup
          onClose={() => setOpened(false)}
          onSelect={handleSelect}
          list={HARDCODE_LANGS}
          value={value}
        />
      )}
    </>
  )
}

export default LanguageSelector
